import { render } from "./BaseStars.vue?vue&type=template&id=08a82838&scoped=true"
import script from "./BaseStars.vue?vue&type=script&lang=js"
export * from "./BaseStars.vue?vue&type=script&lang=js"

import "./BaseStars.vue?vue&type=style&index=0&id=08a82838&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a82838"]])

export default __exports__